module.exports = __webpack_public_path__ + "img/Icon material-delete.f6cc363c.svg";